import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Typography,
  Avatar,
  Card,
  CardContent,
  Grid,
  Divider,
  Tab,
  Tabs,
  Paper,
} from "@mui/material";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import { LocationOn } from "@mui/icons-material";

import Cris from "../assets/img/vereadoresImg/cris.png"
import Erivan from "../assets/img/vereadoresImg/erivan.png"
import Edilmo from "../assets/img/vereadoresImg/edilmo.png"
import Jailson from "../assets/img/vereadoresImg/jailson.png"
import Janaina from "../assets/img/vereadoresImg/janaina.png"
import Leandro from "../assets/img/vereadoresImg/leandro.png"
import Marcia from "../assets/img/vereadoresImg/marcia.png"
import Ovidio from "../assets/img/vereadoresImg/ovidio.png"
import Wagner from "../assets/img/vereadoresImg/wagner.png"

const pessoas = [
  {
    nome: "CRISTILENE BEZERRA DE AZEVEDO",
    setor: "Vereador (a)",
    imagem: Cris,
  },
  {
    nome: "EDILMO LIRA",
    setor: "Vereador (a)",
    imagem: Edilmo,
  },
  {
    nome: "Erivan Elias da Silva",
    setor: "Vereador (a)",
    imagem: Erivan,
  },
  {
    nome: "Jailson Mendonça da Silva",
    setor: "Vereador (a)",
    imagem: Jailson,
  },
  {
    nome: "Janaína Patrícia Bezerra da Silva",
    setor: "Vereador (a)",
    imagem: Janaina,
  },
  {
    nome: "Leandro Euclides Guedes da Costa",
    setor: "Vereador (a)",
    imagem: Leandro,
  },
  {
    nome: "Wagner Ferreira Gonçalves",
    setor: "Vereador (a)",
    imagem: Wagner,
  },
  {
    nome: "Ovídio de Aquino e Silva Neto",
    setor: "Vereador (a)",
    imagem: Ovidio,
  },
  {
    nome: "Marcia Costa Araujo Gomes",
    setor: "Vereador (a)",
    imagem: Marcia,
  },
  {
    nome: "Flávia D’amico Drumond",
    setor: "Administrativo",
    cargo: "Assessora Jurídica",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Francisco Marconi Avelino de Melo",
    setor: "Administrativo",
    cargo: "Tesoureiro",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Joelly Laleska Rodrigues Cosmo",
    setor: "Administrativo",
    cargo: "Controladora",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Jorge Glauco Cabral do Nascimento",
    setor: "Administrativo",
    cargo: "Assessor Legislativo",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Madiane Assunção Paiva da Silva ",
    setor: "Administrativo",
    cargo: "Secretária Executiva",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Magdiel Monteiro do Nascimento",
    setor: "Administrativo",
    cargo: "Assessor Legislativo",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Maria do Perpetuo Socorro dos Santos Azevedo Brito",
    setor: "Administrativo",
    cargo: "Assessora contábil",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Midian Nivia da Silva Rocha ",
    setor: "Administrativo",
    cargo: "Assessora Legislativa",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Murilo Luiz de Assunção ",
    setor: "Administrativo",
    cargo: "Chefe de Gabinete",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Rikelme Ribeiro da Silva",
    setor: "Administrativo",
    cargo: "Assessor Legislativo",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    imagem: "",
    tipo: "Comissionado"
  },
  {
    nome: "Rosângela Soares da Silva Avelino",
    setor: "Administrativo",
    cargo: "Recepcionista",
    imagem: "",
    endereco: "R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP: 59245-000",
    tipo: "Efetiva"
  },
];

const Institucional = () => {
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };

  return (
    <Box sx={{
      padding: 4, width: "100%", margin: "0 auto", [theme.breakpoints.up("md")]: {
        width: "70%"
      },
    }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          padding: 2,
          borderRadius: 1,
          marginBottom: 2,
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          INSTITUCIONAL
        </Typography>
      </Box>

      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", marginBottom: 4, textAlign: "center" }}
      >

      </Typography>

      <Grid container spacing={2} justifyContent="center">
        {[
          { name: "Cristilene Bezerra de Azevedo", role: "PRESIDENTE (A)", avatar: Cris },
          { name: "Ovidio de Aquino e Silva Neto", role: "VICE-PRESIDENTE (A)", avatar: Ovidio },
          { name: "Janaina Patrícia Bezerra da Silva", role: "1 SECRETARIO(A)", avatar: Janaina },
          { name: "Erivan Elias da Silva", role: "2 SECRETARIO(A)", avatar: Erivan },
        ].map((person, index) => (
          <Grid item xs={12} sm={6} md={6} key={index} sx={{ width: '100%' }}>
            <Card
              sx={{
                borderRadius: 2,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <CardContent sx={{ display: 'flex', alignItems: 'center', minHeight: 150 }}>
                <Avatar
                  src={person.avatar}
                  alt={person.name}
                  sx={{ width: 64, height: 64, marginRight: 2 }}
                />
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 'bold', textTransform: 'uppercase' }}
                  >
                    {person.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: '0.875rem', color: 'text.secondary' }}
                  >
                    {person.role}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Divider sx={{ marginY: 4 }} />

      <Paper square>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Câmara" />
          <Tab label="Comissões" />
          <Tab label="Organograma" />
        </Tabs>
      </Paper>

      {tabIndex === 0 && (
        <Box sx={{ marginTop: 4 }}>
          {pessoas.map((pessoa, index) => (
            <Card
              key={index}
              sx={{
                marginBottom: 2,
                borderRadius: 2,
                padding: 2,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", marginBottom: 2 }}
              >
                {pessoa.setor}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 2,
                }}
              >
                <Avatar
                  src={pessoa.imagem}
                  alt={pessoa.nome}
                  sx={{ width: 64, height: 64, marginRight: 2 }}
                />
                <Box>
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bold", textTransform: "uppercase" }}
                  >
                    {pessoa.nome}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {pessoa.cargo}
                    {pessoa.tipo ? ` - ${pessoa.tipo}` : ""}
                  </Typography>
                </Box>
              </Box>
              {pessoa.endereco && (
                <Typography
                  variant="body2"
                  sx={{ display: "flex", alignItems: "center", marginBottom: 1 }}
                >
                  <LocationOn fontSize="small" sx={{ marginRight: 1 }} />
                  {pessoa.endereco}
                </Typography>
              )}
            </Card>
          ))}
        </Box>
      )}

      {tabIndex === 1 && (
        <Box sx={{ marginTop: 4, paddingX: 2 }}>
          {[
            {
              title: "COMISSÃO DE EDUCAÇÃO, SAÚDE, ASSISTÊNCIA E TURISMO",
              people: [
                { name: "Erivan Elias da Silva", role: "Presidente", avatar: Erivan },
                { name: "OVÍDIO DE AQUINO SILVA NETO", role: "Relator", avatar: Ovidio },
                { name: "Edilmo Lira", role: "Membro", avatar: Edilmo }
              ]
            },
            {
              title: "COMISSÃO DE FINANÇAS E ORÇAMENTOS",
              people: [
                { name: "Janaína Patrícia Bezerra da Silva", role: "Presidente", avatar: Janaina },
                { name: "Edilmo Lira", role: "Relator", avatar: Edilmo },
                { name: "Jailson Mendonça da Silva", role: "Membro", avatar: Jailson }
              ]
            },
            {
              title: "COMISSÃO DE LEGISLAÇÃO, JUSTIÇA E REDAÇÃO FINAL",
              people: [
                { name: "Edilmo Lira", role: "Presidente", avatar: Edilmo },
                { name: "Jailson Mendonça da Silva", role: "Relator", avatar: Jailson },
                { name: "OVÍDIO DE AQUINO SILVA NETO", role: "Membro", avatar: Ovidio }
              ]
            },
            {
              title: "COMISSÃO DE OBRAS E SERVIÇOS PÚBLICOS",
              people: [
                { name: "Janaína Patrícia Bezerra da Silva", role: "Presidente", avatar: Janaina },
                { name: "Edilmo Lira", role: "Relator", avatar: Edilmo },
                { name: "OVÍDIO DE AQUINO SILVA NETO", role: "Membro", avatar: Ovidio }
              ]
            }
          ].map((section, sectionIndex) => (
            <Box key={sectionIndex} sx={{ marginBottom: 6 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  marginBottom: 3,
                  textAlign: "center",
                  textTransform: "uppercase"
                }}
              >
                {section.title}
              </Typography>

              <Grid container spacing={3} justifyContent="center">
                {section.people.map((person, index) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "space-between",
                        boxShadow: 4,
                        height: "100%",
                        minHeight: 250, // Garante que todos os cards tenham a mesma altura
                        paddingY: 2,
                        transition: "transform 0.2s ease-in-out",
                        "&:hover": { transform: "scale(1.05)" }
                      }}
                    >
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          textAlign: "center",
                          flexGrow: 1, // Faz com que o conteúdo ocupe o mesmo espaço em todos os cards
                          justifyContent: "start"
                        }}
                      >
                        <Avatar
                          src={person.avatar}
                          alt={person.name}
                          sx={{
                            width: 90,
                            height: 90,
                            marginBottom: 2,
                            border: "2px solid #ccc"
                          }}
                        />
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: "bold",
                            textTransform: "uppercase",
                            marginBottom: 1,
                            minHeight: 48, // Mantém altura fixa para nomes e garante alinhamento
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          {person.name}
                        </Typography>
                        <Typography variant="body2" sx={{ fontSize: "0.875rem", color: "text.secondary" }}>
                          {person.role}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ))}
        </Box>


      )}

      {tabIndex === 2 && (
        <Box sx={{ marginTop: 4 }}>
          <Card>
            <CardContent
              sx={{ cursor: "pointer" }}
              onClick={() => {
                window.open("/ESTRUTURA ORGANIZACIONAL DA CÂMARA MUNICIPAL DE SERRA CAIADA.pdf", "_blank");
              }}>
              <Box sx={{
                padding: "10px",
                textAlign: "center",
                background: theme.palette.primary.main,
                color: theme.palette.primary.text,
                borderRadius: "10px",
              }}>
                <PdfIcon sx={{ fontSize: "50px" }} />
              </Box>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
};

export default Institucional;
